import { apiFetch } from "../../lib/api";
import { getSupabase } from "../../lib/supabase";

const BUCKET = "station-photos";
type AllowedMime = "image/jpeg" | "image/png" | "image/webp";
const ALLOWED_MIME: readonly AllowedMime[] = ["image/jpeg", "image/png", "image/webp"];

type UploadUrl = { url: string; key: string };

function isAllowedMime(value: string): value is AllowedMime {
  return (ALLOWED_MIME as readonly string[]).includes(value);
}

export async function uploadStationPhoto(file: File): Promise<string> {
  if (file.size === 0) {
    throw new Error("photo is empty");
  }
  if (!isAllowedMime(file.type)) {
    throw new Error("photo must be jpeg, png, or webp");
  }
  const contentType: AllowedMime = file.type;

  const { url, key } = await apiFetch<UploadUrl>("/stations/photo-upload-url", {
    method: "POST",
    body: { content_type: contentType },
    auth: true,
  });

  const resp = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  });
  if (!resp.ok) {
    throw new Error(`photo upload failed: ${resp.status}`);
  }

  const { data } = getSupabase().storage.from(BUCKET).getPublicUrl(key);
  return data.publicUrl;
}
